import * as React from "react";
import type { SVGProps } from "react";
const SvgLinkedin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <g clipPath="url(#linkedin_svg__a)">
      <path
        fill="#fff"
        d="M18 3.7a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-12a3 3 0 0 1 3-3h12Zm0 2H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1Zm-10 5a1 1 0 0 1 .993.884L9 11.7v5a1 1 0 0 1-1.993.117L7 16.7v-5a1 1 0 0 1 1-1Zm3-1a1 1 0 0 1 .984.822c.202-.117.411-.223.623-.313.667-.286 1.666-.443 2.568-.16.473.15.948.43 1.3.907.316.425.485.943.519 1.524l.006.22v4a1 1 0 0 1-1.993.117L15 16.7v-4c0-.33-.08-.484-.132-.555a.548.548 0 0 0-.293-.187c-.348-.11-.849-.053-1.182.09a4.22 4.22 0 0 0-1.27.86L12 13.04v3.66a1 1 0 0 1-1.993.117L10 16.7v-6a1 1 0 0 1 1-1Zm-3-2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
      />
    </g>
    <defs>
      <clipPath id="linkedin_svg__a">
        <path fill="#fff" d="M0 .7h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLinkedin;
